import REACT_APP_URLS from '../../../../global-helpers/global-url.helpers';
import axios from 'axios';
import { INewsForgeGeneratedArticle } from '../../NewsForge/models/news-forge.models';
import { IAiForgeSummaryRequestContent, IAiForgeTitleRequestContent } from '../models/ai-assistant.models';

const baseURL = REACT_APP_URLS.REACT_APP_CONTENT_AI_FORGE_API_BASE_URL;
const auth = REACT_APP_URLS.REACT_APP_CONTENT_AI_FORGE_API_AUTH;

export default class AIForgeHttpService {
	static getGeneralInstanceHeaders = () => {
		return {
			'Content-Type': 'application/json',
			Authorization: auth,
		};
	};

	static instance = () => {
		return axios.create({
			baseURL,
			timeout: 30000,
			headers: {
				...AIForgeHttpService.getGeneralInstanceHeaders(),
			},
		});
	};

	static aiForgeSummary = (data: IAiForgeSummaryRequestContent) => {
		return AIForgeHttpService.instance().post(`/summary`, data);
	};

	static aiForgeTitle = (data: IAiForgeTitleRequestContent) => {
		return AIForgeHttpService.instance().post(`/title`, data);
	};

	static aiForgeMetaTitle = (data: IAiForgeTitleRequestContent) => {
		return AIForgeHttpService.instance().post(`/meta-title`, data);
	};
}
